import React, { useState } from "react";
import { Link } from "react-router-dom";
import Stepper from "react-stepper-horizontal";
import ModalDocumentos from "./ModalDocumentos";

const SolicitudAdminForm = ({
  values,
  comentario,
  observacionesData,
  deleteItem,
  handleComentarioChange,
  handleAddDataObs,
  handleSubmit,
  handleChangeEstado,
  nuevoEstado,
  handleNuevoEstadoChange,
  adjuntosData,
  handleDownloadFile,
  selectedFiles,
  handleFileChange,
  handleFileUpload,
  repuestosData,
  cotizaciones,
  solpeds,
  ocs,
  handleDocEntryChange,
  addDocEntry,
  removeDocEntry,
  handleSaveDocEntries,
}) => {
  const {
    proveedor,
    costoreparacion,
    nrotecnicos,
    fecha_falla,
    nivel,
    responsable,
    nombre_activo,
    nombre_item,
    severidad,
    fecha_programada,
    clasificacion,
    repuestos,
    nombresolicitante,
    nombreaprobador,
    imagenes,
    origen_falla,
    periferico,
    observaciones,
    estado_general,
    estado_buque,
    estado_supervisor,
    accionestomadas,
  } = values;

  const {
    titulo,
    fecha,
    usuario,
    fechaComentario,
    descripcion,
    tipoComentario,
  } = comentario;

  const img = values && imagenes && JSON.parse(imagenes);

  const estadoSolicitud =
    values &&
    JSON.parse(estado_general)[JSON.parse(estado_general).length - 1].estado;

  const obs = values && JSON.parse(observaciones);

  const repData = values && repuestos && JSON.parse(repuestos);

  const { cantRep, descRep } = repuestosData;

  const [showModalDoc, setShowModalDoc] = useState(false);

  const formatDate = (date) => {
    if (!date) {
      return "";
    } else {
      return new Date(date).toLocaleString();
    }
  };

  const parseDocEntries = (nroField, fechaField) => {
    if (!nroField && !fechaField) return [];
    try {
      const parsed = JSON.parse(nroField);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {}
    return [{ nro: nroField || "", fecha: fechaField || "" }];
  };

  const allEntries = [
    ...parseDocEntries(values.nrocot, values.fechacotizacion).map((e) => ({
      ...e,
      tipo: "Cotización",
    })),
    ...parseDocEntries(values.nrosolped, values.fechasolped).map((e) => ({
      ...e,
      tipo: "Solped",
    })),
    ...parseDocEntries(values.nrooc, values.fechaoc).map((e) => ({
      ...e,
      tipo: "OC",
    })),
  ].filter((e) => e.nro);

  const isPlanificado2 = accionestomadas === "planificado_2";

  const etapa = () => {
    if (isPlanificado2) {
      let flujo = [{ title: "Planificado" }, { title: "Ejecutado" }];
      const index = flujo.findIndex((item) => item.title === estadoSolicitud);
      return index;
    } else if (nivel !== 1) {
      let flujo = [
        { title: "Abierta" },
        { title: "Aprobada" },
        { title: "Gestionada" },
        { title: "Programada" },
        { title: "En Trabajos" },
        { title: "Conforme" },
        { title: "Cerrado" },
      ];

      const index = flujo.findIndex((item) => item.title === estadoSolicitud);
      return index;
    } else {
      let flujo = [
        { title: "Abierta" },
        { title: "Aprobada" },
        { title: "Gestionada" },
        { title: "Programada" },
        { title: "En Trabajos" },
        { title: "Cerrado" },
      ];

      const index = flujo.findIndex((item) => item.title === estadoSolicitud);
      return index;
    }
  };

  const index = etapa();

  const formatCurrency = (data) => {
    if (data === null || data === undefined) return "$ ";
    const value = data.replace(/[^0-9]/g, "");

    if (value.length < 2) return value;

    let cuerpoFormatoMiles = value
      .toString()
      .split("")
      .reverse()
      .join("")
      .replace(/(?=\d*\.?)(\d{3})/g, "$1.");
    cuerpoFormatoMiles = cuerpoFormatoMiles
      .split("")
      .reverse()
      .join("")
      .replace(/^[\.]/, "");
    return `$ ${cuerpoFormatoMiles}`;
  };

  return (
    <form>
      <div className="row formSolicitud">
        <div className="col-md-12 ">
          <p className="title-section">Información Falla </p>
        </div>
        <div className="col-md-2">
          <label className="mr-2 label-title">Fecha de la falla</label>
          <label className="label-white">{formatDate(fecha_falla)}</label>
        </div>
        <div className="col-md-2">
          <label className=" label-title">Clasificación</label>
          <br />
          <label className="label-white">{clasificacion}</label>
        </div>
        <div className="col-md-3">
          <label className="mr-2 label-title">Nave </label>
          <br />
          <label className="label-white">{nombre_activo}</label>
        </div>
        <div className="col-md-2 ">
          <label className="mr-2 label-title">Equipo</label>
          <br />
          <label className="label-white">{nombre_item}</label>
        </div>
        <div className="col-md-3 ">
          <label className="mr-2 label-title">Periferico (Nro. de parte)</label>
          <br />
          <label className="label-white">{periferico}</label>
        </div>
        <div className="col-md-12 mt-3">
          <p className="title-section">Gestión de la falla </p>
        </div>
        <div className="col-md-4">
          <label className="mr-2 label-title">Severidad de Falla</label>
          <br />
          <label className="label-white">{severidad}</label>
        </div>
        <div className="col-md-4">
          <label className="mr-2 label-title">Nivel</label>
          <br />
          <label className="label-white">{nivel}</label>
        </div>

        <div className="col-md-4">
          <label className="mr-2 label-title">Responsable</label>
          <br />
          <label className="label-white">{responsable}</label>
        </div>
        <div className="col-md-12 mt-2">
          {allEntries.length > 0 ? (
            <table className="table-doc-entries">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Nro</th>
                  <th>Fecha</th>
                </tr>
              </thead>
              <tbody>
                {allEntries.map((e, i) => (
                  <tr key={i}>
                    <td>{e.tipo}</td>
                    <td>{e.nro}</td>
                    <td>{formatDate(e.fecha)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="label-white">Sin documentos contables</p>
          )}
          <button
            type="button"
            className="btn-gestionar-docs"
            onClick={() => setShowModalDoc(true)}
          >
            <i className="fa-solid fa-file-pen"></i> Gestionar Documentos
          </button>
        </div>

        <div className="col-md-3 mt-2">
          <label className="mr-2 label-title">Nª Técnicos</label>
          <br />
          <label className="label-white">{nrotecnicos}</label>
        </div>

        <div className="col-md-3 mt-2">
          <label className="mr-2 label-title">Costo reparación</label>
          <br />
          <label className="label-white">
            {formatCurrency(costoreparacion)}
          </label>
        </div>

        <div className="col-md-3 mt-2">
          <label className="mr-2 label-title">Servicio</label>
          <br />
          <label className="label-white">{proveedor}</label>
        </div>

        <div className="col-md-3 mt-2">
          <label className="mr-2 label-title">Origen Falla</label>
          <br />
          <label className="label-white">{origen_falla}</label>
        </div>

        <div className="col-md-12 mt-3 p-3">
          <p className="label-title">Repuestos Utilizados</p>
          <table className="table-rep mb-0">
            <tr>
              <th>Descripción</th>
              <th>Cantidad</th>
            </tr>
            {repData ? (
              repData.map((c, index) => (
                <tr key={index}>
                  <td>{c.descRep}</td>
                  <td>{c.cantRep}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td>No hay regitros guardados</td>
                <td>No hay regitros guardados</td>
              </tr>
            )}
          </table>
        </div>

        <div className="col-md-12 mt-3">
          <p className="title-section">Estado solicitud</p>
        </div>
        <div className="col-md-12 mt-2 mb-3">
          {isPlanificado2 ? (
            <Stepper
              steps={[{ title: "Planificado" }, { title: "Ejecutado" }]}
              activeStep={index}
            />
          ) : nivel !== 1 ? (
            <Stepper
              steps={[
                { title: "Abierta" },
                { title: "Aprobada" },
                { title: "Gestionada" },
                { title: "Programada" },
                { title: "En trabajos" },
                { title: "Conforme" },
                { title: "Cerrado" },
              ]}
              activeStep={index}
            />
          ) : (
            <Stepper
              steps={[
                { title: "Abierta" },
                { title: "Aprobada" },
                { title: "Gestionada" },
                { title: "Programada" },
                { title: "En trabajos" },
                { title: "Cerrado" },
              ]}
              activeStep={index}
            />
          )}
        </div>

        <div className="col-md-12 mt-3">
          <p className="title-section">Cambiar Estado (Admin)</p>
        </div>
        <div className="col-md-4 mt-2">
          <label className="mr-2 label-title">Estado actual</label>
          <br />
          <label className="label-white">{estadoSolicitud}</label>
        </div>
        <div className="col-md-4 mt-2">
          <label className="mr-2 label-title">Nuevo estado</label>
          <br />
          <select
            value={nuevoEstado}
            onChange={handleNuevoEstadoChange}
            className="filtro-select"
          >
            <option value="">Seleccionar estado</option>
            {isPlanificado2 ? (
              <>
                <option value="Planificado">Planificado</option>
                <option value="Ejecutado">Ejecutado</option>
              </>
            ) : (
              <>
                <option value="Abierta">Abierta</option>
                <option value="Aprobada">Aprobada</option>
                <option value="Gestionada">Gestionada</option>
                <option value="Programada">Programada</option>
                <option value="En Trabajos">En Trabajos</option>
                <option value="Conforme">Conforme</option>
                <option value="Cerrado">Cerrado</option>
                <option value="Rechazada">Rechazada</option>
              </>
            )}
          </select>
        </div>
        <div className="col-md-4 mt-2 d-flex align-items-end">
          <button className="buttonSolicitud" onClick={handleChangeEstado}>
            Actualizar Estado
          </button>
        </div>

        <div className="col-md-12 mt-2"></div>
        <div className="col-md-8 ">
          <label className=" title-section">Comentarios</label>
          <br />

          <div className="comentarios">
            {obs &&
              obs.map((c, index) => (
                <div className="comentario-body" key={index}>
                  <div className="header-comentario">
                    <ul className="userList">
                      <li className="userLi">{c.titulo}</li>
                      <div className="userLiContainer">
                        <li className="userLi">{c.usuario}</li>
                        <li
                          className={
                            c.tipoComentario === "Observación"
                              ? "tipoComentarioLi"
                              : "tipoComentarioLi2"
                          }
                        >
                          {c.tipoComentario}
                        </li>
                        <li>{formatDate(c.fecha)}</li>
                      </div>
                    </ul>
                  </div>
                  <div className="body-comentario">
                    <p className="body-desc">{c.descripcion}</p>
                  </div>
                </div>
              ))}
          </div>
          <div className="comentarios">
            {observacionesData &&
              observacionesData.map((c, index) => (
                <div className="comentario-body" key={index}>
                  <div className="header-comentario">
                    <ul className="userList">
                      <li className="userLi">{c.titulo}</li>
                      <div className="userLiContainer">
                        <li className="userLi">{c.usuario}</li>
                        <li
                          className={
                            c.tipoComentario === "Observación"
                              ? "tipoComentarioLi"
                              : "tipoComentarioLi2"
                          }
                        >
                          {c.tipoComentario}
                        </li>
                        <li>{c.fecha}</li>
                        <li>
                          <button
                            className="borarComent"
                            onClick={() => deleteItem(index)}
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        </li>
                      </div>
                    </ul>
                  </div>
                  <div className="body-comentario">
                    <p className="body-desc">{c.descripcion}</p>
                  </div>
                </div>
              ))}
          </div>
          <form className="cardFormComentarios">
            <input
              required
              value={titulo}
              name="titulo"
              onChange={handleComentarioChange}
              className="titleInput"
              placeholder="Título"
            />
            <input
              required
              value={fecha}
              name="fecha"
              onChange={handleComentarioChange}
              className="selectInput"
              type="datetime-local"
              placeholder="Título"
            />
            <select
              required
              value={tipoComentario}
              name="tipoComentario"
              onChange={handleComentarioChange}
              className="selectInput"
            >
              <option value="">Tipo de comentario</option>
              <option value="Accion Tomada">Acción tomada</option>
              <option value="Observación">Observación</option>
            </select>
            <textarea
              required
              value={descripcion}
              name="descripcion"
              onChange={handleComentarioChange}
              className="textAreaInput"
              placeholder="Descripción"
            ></textarea>
          </form>
          <button className="buttonSolicitud" onClick={handleAddDataObs}>
            Agregar comentario
          </button>
        </div>

        <div className="col-md-4 ">
          <div className="row">
            {estadoSolicitud &&
              (estadoSolicitud === "Programada" ||
                estadoSolicitud === "En Trabajos" ||
                estadoSolicitud === "Cerrado") && (
                <>
                  <div className="col-md-12">
                    <p className="title-section">Programación de trabajos</p>
                  </div>
                  <label type="date" className="mr-2 label-title">
                    Fecha Programada
                  </label>
                  <br />

                  <label className="label-white">
                    {" "}
                    <i className="fa-solid fa-clock"></i>{" "}
                    {formatDate(fecha_programada)}
                  </label>
                </>
              )}
            <label className="title-section">Adjuntos</label>
            <div className="col-md-12 mt-2">
              <input type="file" multiple onChange={handleFileChange} />
              <ul>
                {selectedFiles.map((file, index) => (
                  <li key={index}>{file.name}</li>
                ))}
              </ul>
              <button onClick={handleFileUpload} className="fileUploadButton">
                Subir Archivos
              </button>
            </div>
            <br />
            <div className="col-12 p-0">
              <ui className="list-archivos">
                {adjuntosData &&
                  adjuntosData.map((c) => (
                    <li
                      onClick={(e) => handleDownloadFile(e, c.ruta)}
                      key={c.id}
                    >
                      {c.nombre_archivo}
                    </li>
                  ))}
              </ui>
            </div>
          </div>
        </div>

        <div className="col-12 mt-3">
          <button className="buttonSolicitud" onClick={handleSubmit}>
            Guardar comentarios
          </button>
        </div>
      </div>
      {showModalDoc && (
        <ModalDocumentos
          cotizaciones={cotizaciones}
          solpeds={solpeds}
          ocs={ocs}
          handleDocEntryChange={handleDocEntryChange}
          addDocEntry={addDocEntry}
          removeDocEntry={removeDocEntry}
          handleSaveDocEntries={handleSaveDocEntries}
          handleClose={() => setShowModalDoc(false)}
        />
      )}
    </form>
  );
};

export default SolicitudAdminForm;
